import {
  SubscriptionForm,
  Props as SubscriptionFormProps,
} from './SubscriptionForm';
import { DisclaimerText } from './DisclaimerText';
import { TypographyName } from '../../../theme';

import styles from './SubscriptionFormWithDisclaimer.module.scss';

type SubscriptionFormWithDisclaimerProps = SubscriptionFormProps & {
  disclaimerTextColor?: 'primary' | 'secondary';
  disclaimerTextType?: TypographyName;
};

/**
 * Internal component for using the Subscription Form in the Page builder
 * along with some disclaimer
 */
export const SubscriptionFormWithDisclaimer = ({
  disclaimerTextColor = 'primary',
  disclaimerTextType,
  ...restProps
}: SubscriptionFormWithDisclaimerProps) => {
  return (
    <div className={styles.ctaContainer} data-zds>
      <SubscriptionForm {...restProps} fluidInput={true} />
      <DisclaimerText
        color={disclaimerTextColor}
        textType={disclaimerTextType}
      />
    </div>
  );
};
